import { useContext } from 'react';
import { getText } from '@educaplay/app-core/language';
import { BillingFormContext } from '../../contexts/billingForm';

export const BlockBillingAddress = () => {

    const billingForm = useContext( BillingFormContext );
    const formValues = billingForm?.formValues || {};

    const generateLastLineAddress = () => {
        let lastLineAddress = formValues.zip_code || '';
        if (lastLineAddress != '') {
            lastLineAddress += ' - ';
        }
        lastLineAddress += formValues.town || '';
        if (lastLineAddress != '') {
            lastLineAddress += ' - ';
        }
        lastLineAddress += formValues.province || '';
        if (lastLineAddress != '') {
            lastLineAddress += ' ';
        }
        lastLineAddress += '(' + (formValues.country || '') + ')';
        return lastLineAddress;
    }

    return  <>
                <legend>
                    { getText('datos_de_facturacion') }
                </legend>
                <address>
                    { (formValues.name && formValues.name != '') && <>{ formValues.name }<br /></> }
                    { (formValues.vat_number && formValues.vat_number != '') && <>{ formValues.vat_number }<br /></> }
                    { (formValues.address && formValues.address != '') && <>{ formValues.address }<br /></> }
                    { generateLastLineAddress() }
                </address>
            </>;
}